/*
*
* PayByLink Api
*
* @version 1.0.0
* @author Giorgia Cuozzo
* @since 20-Nov-2024
*/

import { axiosInstance as axios } from 'Api'
import { filterKeys } from 'Route/PayByLink/modules/utils'
import { handlingResponse } from 'Utility/globalMethods'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/payByLink/payByLink')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function getGeneratedLinks (params) {
  const queryParams = new URLSearchParams({
    shopIds: Array.isArray(params.filters[filterKeys.SELECTED_STORES]) ? params.filters[filterKeys.SELECTED_STORES].join(',') : '',
    statuses: params.filters[filterKeys.SELECTED_STATUSES] || '',
    createdDateFrom: params.filters[filterKeys.DATE_FROM] || '',
    createdDateTo: params.filters[filterKeys.DATE_TO] || '',
    search: params.filters[filterKeys.SEARCH_TEXT] || params[filterKeys.SEARCH_TEXT] || '',
    pageSize: params.size,
    pageNumber: params.page
  })

  const url = `/services/marketing-service/public/paymail/urls?${queryParams.toString()}`

  try {
    const response = await axios.get(url)
    return handlingResponse(response)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getGeneratedLinkDetail (params) {
  const queryParams = new URLSearchParams({
    shopId: params.shopId
  })
  const url = `/services/marketing-service/public/paymail/urls/${encodeURIComponent(params.linkId)}?${queryParams.toString()}`

  try {
    const response = await axios.get(url)
    return handlingResponse(response)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getShops (pblShopStatus) {
  let data

  const queryParams = new URLSearchParams({
    payMailShopStatus: pblShopStatus
  })

  try {
    data = await axios({
      method: 'get',
      url: `/services/marketing-service/public/paymail/shops?${queryParams.toString()}`,
      data: {}
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getShopsAndTerminals (pblShopStatus) {
  let data

  const queryParams = new URLSearchParams({
    payMailShopStatus: pblShopStatus
  })

  try {
    data = await axios({
      method: 'get',
      url: `/services/marketing-service/public/paymail/shops/terminal?${queryParams.toString()}`,
      data: {}
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function requirePbl (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/marketing-service/public/paymail/urls',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function generatePblLink (params) {
  let data

  const url = `/services/marketing-service/public/paymail/urls/${params.code}`
  try {
    data = await axios({
      method: 'post',
      url,
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function getShopsInfo (params) {
  let data

  try {
    data = await axios({
      method: 'get',
      url: '/services/marketing-service/public/paymail/shopsInfo',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
